import Alert from '@/assets/icons/Alert';

import styles from '../ExtendedSearch.module.css';

export const FieldErrorExtendedSearch = ({ errorText, smallGap = false }) => (
  <div style={{ top: smallGap ? '42px' : '52px' }} className={styles.fieldError}>
    <Alert width='18px' height='18px' fill='var(--tractie-color-content-error)' aria-hidden='true' />
    <span>{errorText}</span>
  </div>
);
